var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx } from "vue";
var _hoisted_1 = { class: "airport-lookup__fields" };
var _hoisted_2 = {
    key: 1,
    class: "airport-lookup__separator"
};
var _hoisted_3 = ["disabled"];
var _hoisted_4 = {
    key: 0,
    class: "airport-lookup__mobile-from-display"
};
var _hoisted_5 = { class: "tag tag--airport" };
var _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-airplane-right icon--xs icon-color--grey3" }, null, -1 /* HOISTED */);
var _hoisted_7 = { class: "airport-lookup__search" };
var _hoisted_8 = ["placeholder"];
var _hoisted_9 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-arrowleft icon--xs",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_10 = [
    _hoisted_9
];
import debounce from 'lodash/debounce';
import { computed, defineAsyncComponent, ref, watch, nextTick, inject, } from 'vue';
import InputField from '../InputField/InputField.vue';
import DropdownContainer from '../DropdownContainer/DropdownContainer.vue';
import useMatchMedia from '../../hooks/useMatchMedia';
import optiClient from '../../services/api';
import { useElementSize } from '@vueuse/core';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AirportLookup',
    props: {
        showFrom: { type: Boolean, default: true },
        showTo: { type: Boolean, default: true },
        airportFrom: { default: undefined },
        airportTo: { default: undefined },
        showCode: { type: Boolean, default: true },
        isPlanner: { type: Boolean, default: false },
        hideNearby: { type: Boolean, default: false },
        fromAirportLabel: { default: 'Where from?' }
    },
    emits: ["update:airportFrom", "update:airportTo"],
    setup: function (__props, _a) {
        var emits = _a.emit;
        var props = __props;
        var cmsProps = inject('cms-props');
        var dataLoaded = ref(false);
        var AirportList = defineAsyncComponent(function () { return import(
        /* webpackChunkName: "airportList" */
        '../AirportList/AirportList.vue'); });
        var searchTermRef = ref('');
        var showResults = ref(false);
        var activeField = ref('');
        var results = ref([]);
        var nearby = ref([]);
        var error = ref('');
        var loading = ref(true);
        var searchRef = ref();
        var el = ref(null);
        var isMobile = useMatchMedia('(max-width: 416px)');
        var width = useElementSize(el).width;
        var fromId = Math.random().toString(36).substring(2, 12);
        var toID = Math.random().toString(36).substring(2, 12);
        var debouncedSearch = debounce(search, 500);
        var whereFromLabel = computed(function () {
            var _a, _b;
            return ((_a = cmsProps === null || cmsProps === void 0 ? void 0 : cmsProps.fromAirportLabel) === null || _a === void 0 ? void 0 : _a.value)
                ? (_b = cmsProps === null || cmsProps === void 0 ? void 0 : cmsProps.fromAirportLabel) === null || _b === void 0 ? void 0 : _b.value
                : props.fromAirportLabel;
        });
        var whereToLabel = computed(function () {
            var _a, _b;
            return ((_a = cmsProps === null || cmsProps === void 0 ? void 0 : cmsProps.toAirportLabel) === null || _a === void 0 ? void 0 : _a.value)
                ? (_b = cmsProps === null || cmsProps === void 0 ? void 0 : cmsProps.toAirportLabel) === null || _b === void 0 ? void 0 : _b.value
                : 'Where to?';
        });
        function search(term) {
            var _a, _b, _c, _d;
            return __awaiter(this, void 0, void 0, function () {
                var endpoint, res, err_1;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            loading.value = true;
                            error.value = '';
                            _e.label = 1;
                        case 1:
                            _e.trys.push([1, 3, 4, 5]);
                            endpoint = props.isPlanner
                                ? optiClient.planner.getApiV1PlannerAirportsSearch(term, (term === null || term === void 0 ? void 0 : term.length) > 0 ? 'false' : 'true', '800', '', (term === null || term === void 0 ? void 0 : term.length) > 0 ? 'true' : 'false')
                                : optiClient.bookings.getApiV1BookingsAirportsSearch(term, (term === null || term === void 0 ? void 0 : term.length) > 0 ? 'false' : 'true', '800', '', (term === null || term === void 0 ? void 0 : term.length) > 0 ? 'true' : 'false');
                            return [4 /*yield*/, endpoint];
                        case 2:
                            res = _e.sent();
                            results.value = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : [];
                            nearby.value = (_d = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : [];
                            dataLoaded.value = true;
                            return [3 /*break*/, 5];
                        case 3:
                            err_1 = _e.sent();
                            error.value =
                                'We are unable to return results. If the issue persists, please contact our support.';
                            return [3 /*break*/, 5];
                        case 4:
                            loading.value = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
        watch(function () { return showResults.value; }, function (open) {
            if (!open) {
                var parent = document.querySelector('.booking-widget--large');
                var nextFocusTarget = parent === null || parent === void 0 ? void 0 : parent.querySelector('.airport-lookup--desktop');
                if (nextFocusTarget) {
                    nextFocusTarget.focus();
                }
            }
            if (open) {
                nextTick(function () {
                    var _a;
                    (_a = searchRef.value) === null || _a === void 0 ? void 0 : _a.focus();
                });
            }
        });
        var fromValue = computed(function () {
            if (props.airportFrom) {
                if (props.showCode) {
                    return "".concat(props.airportFrom.locCity, " ").concat(props.airportFrom.locIATA);
                }
                else {
                    return "".concat(props.airportFrom.locCity);
                }
            }
            return '';
        });
        var toValue = computed(function () {
            if (props.airportTo) {
                if (props.showCode) {
                    return "".concat(props.airportTo.locCity, " ").concat(props.airportTo.locIATA);
                }
                else {
                    return "".concat(props.airportTo.locCity);
                }
            }
            return '';
        });
        var popularAirports = computed(function () {
            if (typeof props.airportFrom !== 'undefined' &&
                activeField.value === 'to' &&
                props.showTo !== false) {
                var popularDestinations = props.airportFrom.popularDestinations;
                return popularDestinations.split(',');
            }
            return null;
        });
        var displayFilterPredicate = computed(function () { return function (airport) {
            if (typeof props.airportFrom !== 'undefined' &&
                activeField.value === 'to' &&
                airport.locIATA === props.airportFrom.locIATA) {
                return false;
            }
            return true;
        }; });
        var displayNearby = computed(function () {
            if (props.hideNearby) {
                return [];
            }
            else {
                return nearby.value.filter(displayFilterPredicate.value);
            }
        });
        var filteredResults = computed(function () {
            return results.value.filter(displayFilterPredicate.value);
        });
        var displayResults = computed(function () {
            var _a;
            if (!((_a = popularAirports.value) === null || _a === void 0 ? void 0 : _a.length) || searchTermRef.value)
                return filteredResults.value;
            var popular = [];
            for (var i = 0; i < filteredResults.value.length; i++) {
                var airport = filteredResults.value[i];
                if (popularAirports.value.includes(airport.locIATA)) {
                    popular.push(airport);
                }
            }
            return popular.filter(Boolean);
        });
        var activeClass = computed(function () {
            if (activeField.value === 'from') {
                return 'airportfrom';
            }
            else if (activeField.value === 'to') {
                return 'airportto';
            }
            else {
                return '';
            }
        });
        function updateFromFocus() {
            loading.value = true;
            showResults.value = true;
            activeField.value = 'from';
        }
        function updateToFocus() {
            loading.value = true;
            showResults.value = true;
            activeField.value = 'to';
        }
        function updateSearchTermField(event) {
            var _a;
            // @ts-ignore
            searchTermRef.value = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value;
        }
        watch(searchTermRef, function (val) {
            if (val.length > 2 || val.length === 0) {
                debouncedSearch(val);
            }
        });
        watch(activeField, function (val) {
            var _a;
            if (val !== '') {
                // getCloseAirports();
                debouncedSearch(((_a = searchTermRef.value) === null || _a === void 0 ? void 0 : _a.length) > 1 ? searchTermRef.value : '');
            }
        });
        function swap() {
            if (props.airportTo) {
                emits('update:airportFrom', props.airportTo);
            }
            if (props.airportFrom) {
                emits('update:airportTo', props.airportFrom);
            }
        }
        function selectAirport(airport) {
            var _a;
            if (activeField.value === 'from') {
                emits('update:airportFrom', airport);
                if (props.showTo == false) {
                    activeField.value = '';
                    showResults.value = false;
                    return;
                }
                activeField.value = 'to';
                loading.value = true;
                searchTermRef.value = '';
                if (searchRef.value.clearInput) {
                    searchRef.value.clearInput();
                }
                else {
                    searchRef.value.value = '';
                }
                (_a = searchRef.value) === null || _a === void 0 ? void 0 : _a.focus();
            }
            else {
                emits('update:airportTo', airport);
                activeField.value = '';
                showResults.value = false;
            }
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "el",
                ref: el,
                tabindex: "0",
                class: _normalizeClass([
                    {
                        'airport-lookup--desktop': !_unref(isMobile),
                        'airport-lookup--full-screen': _unref(isMobile),
                        'airport-lookup--single-input': props.showTo === false || props.showFrom === false,
                    },
                    'airport-lookup',
                ])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        tabindex: "0",
                        class: "airport-lookup__field",
                        onClick: updateFromFocus,
                        onFocus: updateFromFocus
                    }, [
                        _createVNode(InputField, {
                            modelValue: fromValue.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((fromValue).value = $event); }),
                            "icon-left": _unref(isMobile) || (!_unref(isMobile) && _unref(width) > 412) || !fromValue.value
                                ? [
                                    {
                                        'icon icon-airplane-depart icon-color--grey3': !!_ctx.airportFrom,
                                        'icon icon-airplane-depart icon-color--grey2': !_ctx.airportFrom,
                                    },
                                ]
                                : undefined,
                            name: "airportFrom",
                            readonly: "true",
                            label: whereFromLabel.value,
                            id: _unref(fromId)
                        }, null, 8 /* PROPS */, ["modelValue", "icon-left", "label", "id"])
                    ], 32 /* HYDRATE_EVENTS */),
                    (_ctx.showTo)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            tabindex: "0",
                            class: "airport-lookup__field",
                            onClick: updateToFocus,
                            onFocus: updateToFocus
                        }, [
                            _createVNode(InputField, {
                                modelValue: toValue.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((toValue).value = $event); }),
                                "icon-left": _unref(isMobile) || (!_unref(isMobile) && _unref(width) > 412) || !toValue.value
                                    ? [
                                        {
                                            'icon icon-airplane-arrive icon-color--grey3': !!_ctx.airportTo,
                                            'icon icon-airplane-arrive icon-color--grey2': !_ctx.airportTo,
                                        },
                                    ]
                                    : undefined,
                                name: "airportTo",
                                label: whereToLabel.value,
                                readonly: "true",
                                id: _unref(toID)
                            }, null, 8 /* PROPS */, ["modelValue", "icon-left", "label", "id"])
                        ], 32 /* HYDRATE_EVENTS */))
                        : _createCommentVNode("v-if", true),
                    (_ctx.showTo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("button", {
                                disabled: !_ctx.airportFrom || !_ctx.airportTo,
                                class: "aiport-lookup__swap",
                                "aria-label": "Swap origin and destination",
                                role: "button",
                                onClick: swap,
                                "onKeyup:enter": swap
                            }, [
                                _createElementVNode("i", {
                                    class: _normalizeClass({
                                        'icon icon-swap icon--xs icon-color--grey3': !_ctx.airportFrom || !_ctx.airportTo,
                                        'icon icon-swap icon--xs icon-color--grey1': _ctx.airportFrom || _ctx.airportTo,
                                    })
                                }, null, 2 /* CLASS */)
                            ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_3)
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                (showResults.value)
                    ? (_openBlock(), _createBlock(DropdownContainer, {
                        key: 0,
                        fullScreen: _unref(isMobile),
                        open: showResults.value,
                        class: _normalizeClass(activeClass.value),
                        "onClick:outside": _cache[4] || (_cache[4] = function ($event) { return (showResults.value = false); })
                    }, {
                        default: _withCtx(function () {
                            var _a, _b, _c, _d, _e, _f;
                            return [
                                _createElementVNode("div", {
                                    class: _normalizeClass([
                                        {
                                            'base-model__header': _unref(isMobile),
                                        },
                                        'airport-lookup__header',
                                    ])
                                }, [
                                    (_unref(isMobile) && _ctx.airportFrom && activeField.value === 'to')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.airportFrom.locIATA), 1 /* TEXT */),
                                            _hoisted_6
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createElementVNode("div", _hoisted_7, [
                                        (!_unref(isMobile))
                                            ? (_openBlock(), _createBlock(InputField, {
                                                key: 0,
                                                ref_key: "searchRef",
                                                ref: searchRef,
                                                "default-value": searchTermRef.value,
                                                "icon-left": "icon icon-airplane-depart icon-color--grey2",
                                                name: "airportSearchTerm",
                                                label: activeField.value === 'from' ? whereFromLabel.value : whereToLabel.value,
                                                "onUpdate:inputValue": _cache[2] || (_cache[2] = function (val) { return (searchTermRef.value = val); })
                                            }, null, 8 /* PROPS */, ["default-value", "label"]))
                                            : _createCommentVNode("v-if", true),
                                        (_unref(isMobile))
                                            ? (_openBlock(), _createElementBlock("input", {
                                                key: 1,
                                                ref_key: "searchRef",
                                                ref: searchRef,
                                                class: "airport-lookup__mobile-input",
                                                type: "text",
                                                name: "airportSearchTerm",
                                                placeholder: activeField.value === 'from' ? whereFromLabel.value : whereToLabel.value,
                                                onInput: updateSearchTermField
                                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_8))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    (_unref(isMobile))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: "button--text button--icon base-model__header-close m-r--8",
                                            "aria-label": "Dismiss modal",
                                            role: "button",
                                            onClick: _cache[3] || (_cache[3] = function ($event) { return (showResults.value = false); })
                                        }, _hoisted_10))
                                        : _createCommentVNode("v-if", true)
                                ], 2 /* CLASS */),
                                _createVNode(_unref(AirportList), {
                                    nearby: displayNearby.value,
                                    results: displayResults.value,
                                    popularAirports: popularAirports.value,
                                    isPlanner: _ctx.isPlanner,
                                    isTo: activeField.value === 'to',
                                    error: error.value,
                                    loading: loading.value,
                                    searchTerm: searchTermRef.value,
                                    "all-results-text": popularAirports.value && popularAirports.value.length > 0
                                        ? (_b = (_a = _unref(cmsProps)) === null || _a === void 0 ? void 0 : _a.popularDestinationsLabel.value) !== null && _b !== void 0 ? _b : 'Popular destinations'
                                        : (_d = (_c = _unref(cmsProps)) === null || _c === void 0 ? void 0 : _c.allAiportsLabel.value) !== null && _d !== void 0 ? _d : 'All airports',
                                    "near-you-text": ((_e = _unref(cmsProps)) === null || _e === void 0 ? void 0 : _e.nearbyAirportsLabel.value)
                                        ? (_f = _unref(cmsProps)) === null || _f === void 0 ? void 0 : _f.nearbyAirportsLabel.value
                                        : 'Near you',
                                    onItemSelected: selectAirport
                                }, null, 8 /* PROPS */, ["nearby", "results", "popularAirports", "isPlanner", "isTo", "error", "loading", "searchTerm", "all-results-text", "near-you-text"])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["fullScreen", "open", "class"]))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
